import packageJson from '../../package.json';

// Build number will be injected by GitHub Actions during CI/CD
// Format: YYYYMMDD.BuildNumber (e.g., 20250207.2)
declare const __BUILD_NUMBER__: string;

export const appVersion = {
  version: packageJson.version,
  buildNumber:
    typeof __BUILD_NUMBER__ !== 'undefined' && __BUILD_NUMBER__ !== '__BUILD_NUMBER__'
      ? __BUILD_NUMBER__
      : 'dev',
};

/**
 * Get formatted version string for display
 * @returns Formatted version string (e.g., "v1.0.0 | build #20250207.2")
 */
export const getVersionString = (): string => {
  return `v${appVersion.version} | build #${appVersion.buildNumber}`;
};
